// removed by extract-text-webpack-plugin
module.exports = {"header":"styles__header___1Wav0","logoSmall":"styles__logoSmall___uagku","menuButton":"styles__menuButton___3GW2e","pageTitle":"styles__pageTitle___ydU9M","inner":"styles__inner___2iz_0","logo":"styles__logo___1uGVe","menuButtonText":"styles__menuButtonText___2BCnh","waves":"styles__waves___8pHnZ","wavesShow":"styles__wavesShow___2Gssb","wave":"styles__wave___3A2K-","rotate":"styles__rotate___1hKE_","fadein":"styles__fadein___3Rgei","slideFromRight":"styles__slideFromRight___2RuXL"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/Header/styles.scss
// module id = ./resources/assets/js/components/Header/styles.scss
// module chunks = 0